import React, { useState } from "react";
import {
  MotifInput,
  MotifIcon,
  MotifTooltip,
  MotifButton,
  MotifCheckbox,
} from "@ey-xd/motif-react";
import {
  checkPwdIcon,
  lockIcon,
  infoIcon,
  eyeCloseIcon,
  eyeIcon,
  deleteIcon,
  
} from "../../common/MotifIcons";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { getImagePath, getFileTypeName, getDateTimeFormat, getUploadedByFormat } from "../../common/utility/utility";
import SmallCircleLoader from "./SmallCircleLoader";

import "./ViewFiles.scss"; // Assuming you have a CSS file for styling
import { hexToRgb } from "@mui/material";
import { height } from "@mui/system";

const PendingFileTile = ({
  file,
  onPasswordChange,
  passwords,
  handleUnlockFile,
  isCorrectPassword,
  showError,
  rowData,
  handleRemoveFile,
  isSelected,
  onSelectFile,
  onDelete,
  providePassword=false,
  showValidatingLoader,
  searchValue,
  isDeleting = false
}) => {
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const [openDialog, setOpenDialog] = React.useState(false);
  const [fileToDelete, setFileToDelete] = useState(null); // State to store the file to delete

  const togglePasswordVisibility = () => {
    setIsPasswordVisible(!isPasswordVisible);
  };
  const handleDialogClose = () => {
    setOpenDialog(false);
    setFileToDelete(null);
  };
  const handleDeleteClick = (e) => {
    e.stopPropagation(); // Prevent checkbox toggle when clicking delete
    onDelete(file.controlId); // Call the delete function with the control ID
  };

  const handleDialogConfirm = () => {
    handleRemoveFile({
      controlId: String(fileToDelete.controlId),
      area: rowData?.area,
      noOfDeleteIcon: 1,
      noOfUploadedFiles: rowData?.noOfUploadedFiles,
      engagementTrackingStatus: rowData?.engagementTrackingStatus,
      engagementId: rowData?.engagementId,
      isPending: true,
    });
    handleDialogClose();
  };
   const getHighlightedNodes = (text, highlight) => {
      if (!highlight) return <span className="ft-file-name-text">{text}</span>;
      const escaped = highlight.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
      const re = new RegExp(escaped, 'ig');
      const nodes = [];
      let lastIndex = 0;
      let m;
      while ((m = re.exec(text)) !== null) {
        const start = m.index;
        const end = re.lastIndex;
        if (start > lastIndex) nodes.push(text.slice(lastIndex, start));
        nodes.push(
          <span key={start} className="search-highlight" style={{ backgroundColor: 'yellow' }}>
            {text.slice(start, end)}
          </span>
        );
        lastIndex = end;
      }
      if (lastIndex < text.length) nodes.push(text.slice(lastIndex));
      return <span className="ft-file-name-text">{nodes}</span>;
    };

  const rawname = String.raw`${file.fileName}`;
  const filename = rawname.split("\\").pop();
   const isSearching = (searchValue || "").trim().length > 0;
  return (
    <>
      <div className="ft-file-item-pending">
         <div className={`ft-file-icon-pending  ${ !providePassword ? "" :"ft-file-icon-protected" }`}>
        {!providePassword &&  <MotifCheckbox
            id={`file-${file.controlId}`}
            onChange={() => onSelectFile(file.controlId)} // Handle file selection
            checked={isSelected} // Reflect selection state
          />
        }
          <img
            src={getImagePath(file.fileName)}
            alt={`${getFileTypeName(file.fileName)} icon`}
          />
        </div>
        {/* <div className="ft-file-protected"> */}
        <div
          className={`ft-file-details ${
            !isCorrectPassword ? "ft-file-protected" : ""
          }`}
        >
          <div className={`ft-file-name ${ !providePassword ? "ft-grid-pendingProtected" :"ft-grid-passwordProtected" }`} title={filename}>
          <div className="ft-file-name-text">{getHighlightedNodes(filename, searchValue)} <div
            className={`ft-file-type`}
          >
          <span><span className="spn-file-type-label"> Type:</span> {getFileTypeName(file.fileName)} File </span>  
          </div></div>    
          {!providePassword &&  <MotifTooltip
              className="file-tooltip"
              allowClick
              allowHover
              closeButtonProps={{}}
              flip
              id="tooltip"
              placement="auto"
              trigger={
                <MotifIcon src={infoIcon} style={{ marginTop: "2px" }} />
              }
              variant="alt"
              style={{ width: "1px", height: "1px" }}
            >
              <div className="file-tooltip-line">Uploaded by: {file.uploadedBy}</div>
              <div className="file-tooltip-line">Created Date: {file?.dateCreated ? getDateTimeFormat(file.dateCreated) : ""}</div>
                       
            </MotifTooltip> }     
             {!isCorrectPassword && (
              <div>
            <div className="ft-file-password-wrapper">
              <div className="input-container">
                <MotifInput
                  placeholder="Enter password"
                  className="ft-file-password-input input-container-pendingFiles"
                  onChange={(e) =>
                    onPasswordChange(file.controlId, e.target.value)
                  }
                  value={passwords[file.controlId] || ""}
                  type={isPasswordVisible ? "text" : "password"}
                  hideClearButton={true}
                />
                {passwords[file.controlId] && (
                  <button
                    className="ft-password-toggle ft-password-toggle-pending"
                    onClick={togglePasswordVisibility}
                  >
                    <MotifIcon
                      src={isPasswordVisible ? eyeCloseIcon : eyeIcon}
                    />
                  </button>
                )}
              </div>
              <div className="tooltip">
             {showValidatingLoader?< div className="pt-file-unlock-circle"> <SmallCircleLoader /> </div>:  
             <>
             <MotifTooltip
                                                                       allowClick
                                                                       allowHover
                                                                       closeButtonProps={{}}
                                                                       flip
                                                                       id="tooltip"
                                                                       placement="auto"
                                                                       trigger={
                                                                           <MotifIcon
                                                                               style={{ marginTop: '6px' }}
                                                                               src={checkPwdIcon}
                                                                               className="motif-icon-check-pending"
                                                                               onClick={() => handleUnlockFile(file)}
                                                                           />
                                                                       }
                                                                       variant="default"
                                                                   >
                                                                      Verify Password
                                                                   </MotifTooltip>
                 {/* <button
                  className="pt-file-unlock"
                  onClick={() => handleUnlockFile(file)}
                >
                  <MotifIcon src={checkPwdIcon} />
                </button>
                <span className="tooltiptext">Verify Password</span> */}
             
             </>}
                </div>
            
            </div>
            {!isCorrectPassword && showError && (
            <div className="pt-file-error-message">
              Please provide correct password.
            </div>
          )}
            </div>
          )}
          
       
          </div>
         
          <div className="pending-file-meta-row">
            <span className="pending-file-meta-value">
              {file.dateCreated
                ? getDateTimeFormat(file.dateCreated) +","
                : ""}
            </span>
            <span className="pending-file-meta-label">Uploaded by:</span>
            <span className="pending-file-meta-value">{getUploadedByFormat(file.uploadedBy)}</span>
            </div>
           { isSearching && <div className="ft-file-path" title={file.filePath}>Path : {file.filePath} </div>}
      
         
        </div>
        {/* </div> */}
        <div className="ft-file-actions ft-file-actions-pendingFiles" style={{marginTop: "-1px"}}>
          {!isCorrectPassword && (
            <>
              <button 
                className="ft-file-remove ft-file-remove-pendingFiles" 
                disabled={isDeleting}
                onClick={handleDeleteClick}
              >
                {isDeleting ? (
                  <SmallCircleLoader color="#ff0000" />
                ) : (
                  <MotifIcon src={deleteIcon} />
                )}
              </button>
              <button className="ft-file-lock-icon">
              {!isDeleting && (
                <MotifIcon src={lockIcon} className="ft-file-lock-icon" />
              )}
              </button>
            </>
          )}
        </div>
      </div>
      <Dialog
        open={openDialog}
        onClose={handleDialogClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="deleteDialogBox"
      >
        <DialogTitle>
          <IconButton
            onClick={handleDialogClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
            }}
          >
            <CloseIcon />
          </IconButton>
          <img
            src={require("../../common/images/warning-triangle.png")}
            alt={"Note"}
          />
        </DialogTitle>
        <DialogContent>
          <span id="alert-dialog-description">
            <strong> Do you want to delete this file?</strong>
            <p>Once it is deleted, you cannot reverse the action.</p>
          </span>
        </DialogContent>
        <DialogActions>
          <MotifButton
            onClick={handleDialogClose}
            color="secondary"
            variant="secondary"
            autoFocus
          >
            Cancel
          </MotifButton>
          <MotifButton onClick={handleDialogConfirm} color="primary" autoFocus>
            Yes
          </MotifButton>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default PendingFileTile;
